import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

import ChatListEmpty from "@/views/Home/components/ChatListEmpty.vue";
import { isExpand } from "@/views/Home/useData/useHomePage";
import ChatListHistory from "@/views/Home/components/ChatListHistory.vue";
import { bindDialogue } from "@/views/Home/useData/module/chat";
import publicStore from "@/store/publicStore";
import {
  dialogueStatus,
  dialogueList,
  init,
  addDialogue,
} from "@/views/Home/useData/module/dialogue";

import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { onBeforeMount, computed, watch } from "vue";
import { storeToRefs } from "pinia";
import { chatStatus } from "@/views/Home/useData/module/chat";
import { ElMessage } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatList',
  setup(__props) {

const { isLogin } = storeToRefs(publicStore());

onBeforeMount(() => {
  console.log("onBeforeMount");
  // init();

  //设置类型 聊天发送时设置
  // setType("deep-seek-v3");
  // setType("R1");
});

const isReplying = computed(() => {
  return chatStatus.isReplying;
});

const addNewDialogue = () => {
  if (!isLogin.value) {
    ElMessage.warning("请登录后使用");

    return openLoginDialog();
  }

  if (isReplying.value) {
    return ElMessage({
      message: "当前对话正在进行中，请先结束当前对话",
      type: "warning",
      duration: 1000,
    });
  }
  addDialogue();
};

watch(
  isLogin,
  () => {
    init();
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_ChatLineSquare = _resolveComponent("ChatLineSquare")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat-base", { 'base-compact': !_unref(isExpand) }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["add-new-btn", { 'btn-compact': !_unref(isExpand) }])
    }, [
      (!_unref(isExpand))
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            class: "box-item",
            effect: "dark",
            content: "开启新对话",
            placement: "right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, {
                onClick: addNewDialogue,
                size: 20,
                color: `#000`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ChatLineSquare)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(isExpand))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: addNewDialogue
          }, "开启新对话"))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(dialogueList).length === 0)
      ? (_openBlock(), _createBlock(ChatListEmpty, { key: 0 }))
      : _withDirectives((_openBlock(), _createBlock(ChatListHistory, { key: 1 }, null, 512)), [
          [_vShow, _unref(isExpand)]
        ])
  ], 2))
}
}

})